import styled from 'styled-components';
import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import { Colors } from '~/config/Colors';

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .row {
    margin-bottom: 0.5em;
  }

  .row-left {
    margin-bottom: 0.5em;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .no-margin {
    margin: 0 !important;
  }

  .header {
    padding: 0 0.6em;
    margin-bottom: 1em;

    .h-descricao {
      font-size: 0.7125em;
      line-height: 0.8em;
      color: ${Colors.Color7};
    }
  }

  .title_p {
    text-align: left;
    margin-left: 1em;
    max-width: 100%;
    font-weight: 500;
    font-size: 0.75em;
    line-height: 1.8em;
    margin-bottom: 0.5em;
    color: ${Colors.Color7};
    ${props => props.row && `width: 6em; margin-bottom: 0em;`}
  }

  .novo-horario {
    cursor: pointer;
    padding: 0 1.7em;
    align-items: center;
    display: flex;
    justify-content: center;
    height: 2em;
    width: 8em;
    background-color: ${Colors.Color4};
    border: 0.25em solid ${Colors.Color4};
    border-radius: 0.5em;
    margin-right: 0.6em;

    .adiciona-horario {
      font-size: 0.88em;
      font-weight: 500;
      color: ${Colors.Color13};
    }
  }

  .footer {
    position: fixed;
    bottom: 1em;
    left: 1em;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .content-top {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1em;
  }

  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    box-shadow: ${localStorage.getItem("tema") == "E" ? "0px 0px 19px 0px rgb(4 4 4 / 25%)" : "0px 0px 20px rgba(0,0,0,0.07)"} !important;
    margin-bottom: 1.5em;
    border-radius: 0.4em;
    padding: 0em 1em 0em 1em !important;

    .content-top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .card-cod {
        background: ${Colors.Color2};
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 31%;
        margin-top: 0.75em;
        margin-bottom: 1.25em;

        .cod {
          font-size: 0.75em;
          font-weight: 500;
          color: ${Colors.Color4};
        }
      }
    }
  }

  .atv-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    box-shadow: ${localStorage.getItem("tema") == "E" ? "0px 0px 19px 0px rgb(4 4 4 / 25%)" : "0px 0px 20px rgba(0,0,0,0.07)"} !important;
    margin-bottom: 0.5em;
    border-radius: 0.4em;

    .atv-content-top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background: ${Colors.Color23};
      border-radius: 0.4em;
      padding: 0.5em 1em 0.5em 1em;

      .card-titulo {
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        width: 100%;

        .titulo {
          font-size: 0.75em;
          font-weight: 500;
          color: ${Colors.Color4};
        }
      }

      .card-check {
        cursor: pointer;
        width: 1.5em;
        height: 1.5em;
        background: ${Colors.Color13};
        border-radius: 0.4em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }

      .checked {

        span {
          width: 1em;
          height: 1em;
          background: ${Colors.Color4};
          display: block;
          border-radius: 0.3em;
        }
      }
    }

    .atv-content-body {
      margin-top: 0.5em;

      .col {
        margin-bottom: 0.5em !important;
      }
    }
  }
`;

export const SecaoTicket = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0.4em;

  .atv-content-body {
    width: 98%;
    background: ${Colors.Color22};
    margin-left: 1%;
    border-radius: 0 0 0.6em 0.6em;
    padding: 1em 0.6em;

    .content-top {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 1em;

      .title_p {
        margin: 0;
      }

      .novo-horario {
        margin: 0;
      }
    }

    .item-desc {
      p, div {
        background: ${Colors.Color22} !important;
        color: ${Colors.Color7} !important;
      }
    }

    .item-desc.no-html {
      white-space: pre;
      white-space: pre-line;
      white-space: pre-wrap;
    }

    .item-horario {
      background: ${Colors.Color26};
      border-radius: 0.5em;
      height: 3em;
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      margin-bottom: 0.4em;

      .col {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 0;

        p {
          width: 10em;
          margin: 0;
        }

        img {
          margin-right: 0.6em;
        }
      }
    }

    .item-horario::before {
      content: "";
      background: ${Colors.Color4};
      height: 60%;
      width: 0.1em;
      position: absolute;
      top: 20%;
      border-radius: 0.4em;
    }
  }
`;

export const ItemTicket = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${(props) => props?.item ? Colors.Color26 : Colors.Color4};
  color: ${(props) => props?.item ? Colors.Color7 : Colors.Color9};
  width: 100%;
  height: 2.6875em;
  border-radius: 0.5em;
  margin-bottom: ${(props) => props?.item ? "0em" : "0.4em"};
  padding: 0.5em 1em 0.5em 1em;
  cursor: pointer;

  ${(props) => props?.excluido && `
    opacity: 0.5;

    .text-col {
      text-decoration: line-through;
    }
  `}

  .text-col {
    font-size: 0.8em;
  }

  .col-acoes-final {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 0.6em;
    width: 100%;

    img {
      cursor: pointer;
      width: 1.1em;
      height: 1.1em;
      flex-shrink: 0;
    }
  }
`;

export const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 2.2em;
  height: 1.2em;
  cursor: pointer;
  flex-shrink: 0;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    inset: 0;
    background: ${Colors.Color6};
    box-shadow: inset 0 0 0 0.06em ${Colors.Color5};
    border-radius: 1em;
    transition: 0.2s;
  }

  .slider::before {
    content: "";
    position: absolute;
    height: 0.9em;
    width: 0.9em;
    left: 0.15em;
    top: 0.15em;
    background: #fff;
    border-radius: 50%;
    transition: 0.2s;
  }

  input:checked + .slider {
    background: ${Colors.Color4};
  }

  input:checked + .slider::before {
    transform: translateX(1em);
  }

  input:disabled + .slider {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
